import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {

  @Input() customData: any

  mapData: any = []
  constructor() { }

  ngOnInit(): void {
    this.mapData.push(this.customData)
  }

}
